import throttle from 'lodash/throttle';
import { useEffect, useRef } from 'react';
import Dimensions from '@utils/dimensions';

import useForceUpdate from './useForceUpdate';

export default function useDimensions(only?: 'width' | 'height') {
  const dimensionsRef = useRef({
    width: Dimensions.get('window').width,
    height: Dimensions.get('window').height,
  });
  const forceRerender = useForceUpdate();

  function hasChanged(width: number, height: number) {
    return !!(
      (only !== 'height' && width !== dimensionsRef.current.width) ||
      (only !== 'width' && height !== dimensionsRef.current.height)
    );
  }

  function _setDimensions(width: number, height: number) {
    if (!hasChanged(width, height)) return;

    dimensionsRef.current.width = width;
    dimensionsRef.current.height = height;

    forceRerender();
  }
  const setDimensions = throttle(_setDimensions, 50);

  useEffect(() => {
    const handler = ({ window }: { window: any }) => {
      const { width, height } = window;
      setDimensions(width, height);
    };

    Dimensions.addEventListener('change', handler);

    return () => {
      Dimensions.removeEventListener('change', handler);
    };
  }, []);

  return dimensionsRef.current;
}
